const riot = require('riot');

riot.tag2('item-note', '<a class="relative block px12 pt12 py4 transition hover-trigger hover-bg-white {opts.isCurrent ? \'bg-white\' : \'bg-background_light_secondary\'}" href="{opts.link ? opts.link : getLink()}" onclick="{opts.onclick}"> <div class="absolute t0 b0 l0" if="{opts.enableActiveBorder &amp;&amp; opts.isCurrent}"> <div class="w2 h-full bg-primary"></div> </div> <div class="f fm mb8"><i class="icon-fill_pin text-label_dark_medium fs16 mr4" if="{opts.item.isPinned()}"></i> <div class="lh15 word-break-all mr2 {\'text-gray\': !isActive()}">{opts.item.data.title || ⁗(新しいノート)⁗}</div> </div> <div class="f flex-wrap mb8" if="{opts.item.data.tags.length}"> <div class="mr4 mb4" each="{tag in opts.item.data.tags}"> <div class="bg-darkgray rounded-full px6 py4 text-white fs11" onclick="{onClickTag}">#{tag}</div> </div> </div> <div class="bg-background_light_secondary opacity-50 border-bottom mxn12" if="{opts.view === &quot;board&quot;}"></div> <div class="f fm fbw mt4"> <div class="f fm"> <div class="f fm p4 text-label_dark_medium mln4" onclick="{onGoMessages}"><i class="icon-comment pt1 fs16 mr4 tooltip" aria-label="メッセージへ" data-tooltip-position="right"></i> <div class="fs12 lh15">{opts.item.data.message_count}件</div> </div> <div class="f fm p4" onclick="{onOpenScheduleModal}"><i class="icon-time pt2 fs16 text-label_dark_medium mr4 tooltip" aria-label="期限を設定" data-tooltip-position="right"></i> <div class="fs12 lh15 {opts.item.getTermColor()}" if="{isShowTerm()}" data-is="atom-time" date="{opts.item.data.end_at}" position="right"></div> </div> <div class="f fm p4 text-label_dark_medium" if="{opts.item.data.child_note_refs?.length &gt; 0}" onclick="{openChildNotesModal}"><i class="icon-remind pt1 fs16 mr4 tooltip" aria-label="子タスク" data-tooltip-position="right"></i> <div class="fs12 lh15">{opts.item.data.child_note_refs.length}</div> </div> </div> <div data-is="atom-assign" note="{opts.item}"></div> </div> <div class="f fm fbw my8" if="{!opts.hideStatus}"> <div class="f fm"> <div class="mr8" if="{opts.showProject}" data-is="atom-project" item="{opts.item.getProject()}"></div> <div class="cursor-pointer mr16" data-is="atom-status" note="{opts.item}"></div> </div> </div> <div class="absolute t4 r4" if="{isUnread()}"> <div class="f fh circle bg-alert_primary font-lato fs10 lh13 text-white bold {getUnreadLabel() ? &quot;s16 pb2&quot; : &quot;s8 m4&quot;}">{getUnreadLabel()}</div> </div></a>', 'item-note,[data-is="item-note"]{display:block}', '', function(opts) {

    const ACTIVE_TAGS = ['index', 'note', 'document', 'knowledge', 'lifehack'];

    this.on('mount', async () => {
    });

    this.isCurrent = () => {
      if (!this.opts.currentNote) return false;

      return this.opts.currentNote.id === this.opts.item.id;
    };

    this.isActive = () => {

      if (this.opts.item.isPinned()) {
        return true;
      }

      if (this.opts.item.data.tags.some(tag => ACTIVE_TAGS.includes(tag))) {
        return true;
      }

      let now = dayjs();
      let d = now.diff(this.opts.item.data.updated_at, 'day');
      let is_active = d < 30;

      return is_active;
    };

    this.isUnread = () => {
      let inbox = this.opts.item.getInbox();

      if (inbox) {
        return !inbox.data.looked;
      }
    };

    this.getUnreadLabel = () => {
      let inbox = this.opts.item.getInbox();
      return inbox.isMention() ? '@' : '';
    };

    this.getLink = () => {
      if (this.opts.view) {
        return `/${this.opts.item.path}?view=${this.opts.view}`;
      }
      else {
        return `/${this.opts.item.path}`;
      }
    };

    this.onGoMessages = (e) => {
      e.preventDefault();
      e.stopPropagation();
      spat.router.push(`/${this.opts.item.path}/messages`);
    };

    this.onOpenScheduleModal = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      let modal = spat.modal.open('modal-calendar', {note: this.opts.item});
      await modal.waitClose();
      await this.opts.item.refresh();
      this.update();
    };

    this.openChildNotesModal = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      let modal = spat.modal.open('modal-child-notes', {
        note: this.opts.item,
      });

      await modal.waitClose();
      await this.opts.item.refresh();
      this.update();
    };

    this.isShowTerm = () => {
      return this.opts.item.data.end_at;
    };

    this.onClickTag = (e) => {
      e.stopPropagation();
      e.preventDefault();

      let url = new URL(location.href);
      url.searchParams.set('q', '#' + e.item.tag);
      spat.router.replace(url.href);
    };
});